import { Directive, DirectiveBinding } from 'vue';

interface ContractProcessStateDirectiveValue {
   hasContract: boolean;
   color?: string;
   isSelected?: boolean;
}

function applyContractProcessStateStyle(el: HTMLElement, binding: DirectiveBinding<ContractProcessStateDirectiveValue | undefined>) {
   if (!binding.value?.hasContract) {
      el.style.removeProperty('background-color');
      el.style.removeProperty('border-color');
      return;
   }

   const color = binding.value?.color ?? 'var(--surface-container-1)';
   if (!color) {
      el.style.removeProperty('background-color');
      el.style.removeProperty('border-color');
      return;
   }

   const cellColor = binding.value?.isSelected ? `color-mix(in srgb, ${color} 95%, black)` : color;
   el.style.backgroundColor = cellColor;
   el.style.removeProperty('border-color');
}

const contractProcessStateDirective: Directive<HTMLElement, ContractProcessStateDirectiveValue | undefined> = {
   mounted: applyContractProcessStateStyle,
   updated: applyContractProcessStateStyle,
};

export default contractProcessStateDirective;
